import {Routes} from '@angular/router';
import {UnitRegisterComponent} from '@app/unit/register/unit-register.component';

export const unitRegisterRouter: Routes = [
  {
    path: 'dang-ky-don-vi',
    component: UnitRegisterComponent,
    data: {
      pageTitle: 'unit.register.Đăng ký đơn vị_title',
    },
  },
];
